// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================================================
   Figma Datepicker Design System Styles
   Figma Specification Node: 140:10389 (Calendar 166:5380, Input 166:5483)
   ========================================================================== */

/* Root Wrapper */
.figma-datepicker-root {
  display: flex;
  flex-direction: column;
  width: 100%;
  font-family: var(--font-family-primary, "Lexend", -apple-system, sans-serif);
  position: relative;
  text-align: left;
}

.figma-datepicker-root--inline {
  display: inline-flex;
  width: auto;
}

/* Label (Figma Node 166:5484) */
.figma-datepicker__label {
  display: flex;
  align-items: center;
  font-family: var(--font-family-primary, "Lexend", sans-serif);
  font-size: 13px;
  font-weight: 500;
  line-height: normal;
  color: var(--text-primary, #142624);
  margin-bottom: 6px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.figma-datepicker__required {
  color: var(--danger-default, #e04434);
  margin-left: 3px;
  font-weight: 600;
}

/* Input Container (Figma Node 166:5485) */
.figma-datepicker__input-container {
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important;
  gap: 8px !important;
  height: 40px !important;
  padding: 0 12px 0 14px !important;
  background-color: var(--surface-primary, #ffffff) !important;
  border: 1px solid var(--border-default, #cdd6d4) !important;
  border-radius: var(--radius-md, 10px) !important;
  color: var(--text-primary, #142624) !important;
  box-sizing: border-box !important;
  cursor: pointer !important;
  -webkit-user-select: none !important;
          user-select: none !important;
  transition: border-color 0.15s ease, box-shadow 0.15s ease,
    background-color 0.15s ease !important;
  position: relative !important;
  width: 100% !important;
}

.figma-datepicker__input-container:hover:not(
    .figma-datepicker__input-container--disabled
  ) {
  border-color: var(--border-strong, #aebab8) !important;
}

.figma-datepicker__input-container:focus-within:not(
    .figma-datepicker__input-container--disabled
  ),
.figma-datepicker__input-container--focused {
  border-color: var(--interactive-default, #0f766e) !important;
  box-shadow: none !important;
  outline: none !important;
}

/* Size Variants */
.figma-datepicker__input-container--sm {
  height: 32px !important;
  padding: 0 10px !important;
  border-radius: var(--radius-sm, 6px) !important;
}

.figma-datepicker__input-container--md {
  height: 40px !important;
  padding: 0 12px 0 14px !important;
  border-radius: var(--radius-md, 10px) !important;
}

.figma-datepicker__input-container--lg {
  height: 48px !important;
  padding: 0 16px !important;
  border-radius: var(--radius-md, 10px) !important;
}

/* Disabled State */
.figma-datepicker__input-container--disabled {
  background-color: var(--surface-secondary, #f4f7f7) !important;
  border-color: var(--border-subtle, #e8edec) !important;
  color: var(--text-disabled, #aebab8) !important;
  cursor: not-allowed !important;
  opacity: 0.8 !important;
}

/* Error State */
.figma-datepicker__input-container--error {
  border-color: var(--danger-default, #e04434) !important;
}

.figma-datepicker__input-container--error:focus-within {
  box-shadow: none !important;
}

/* Inner Input Element (Figma Node 166:5486) */
.figma-datepicker__input {
  flex: 1 1 !important;
  min-width: 0 !important;
  border: none !important;
  background: transparent !important;
  outline: none !important;
  font-family: var(--font-family-primary, "Lexend", sans-serif) !important;
  font-size: 14px !important;
  font-weight: 400 !important;
  color: var(--text-primary, #142624) !important;
  padding: 0 !important;
  margin: 0 !important;
  line-height: normal !important;
  cursor: pointer !important;
  -webkit-user-select: none !important;
          user-select: none !important;
}

.figma-datepicker__input::placeholder {
  color: var(--text-tertiary, #6b7b78) !important;
  opacity: 1 !important;
}

.figma-datepicker__input:disabled {
  color: var(--text-disabled, #aebab8) !important;
  cursor: not-allowed !important;
}

/* Right Actions / Icons (Figma Node 166:5487) */
.figma-datepicker__actions {
  display: flex !important;
  align-items: center !important;
  gap: 6px !important;
  flex-shrink: 0 !important;
}

.figma-datepicker__clear-btn {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  border: none !important;
  background: transparent !important;
  color: var(--text-tertiary, #8a9896) !important;
  padding: 2px !important;
  border-radius: var(--radius-xs, 4px) !important;
  cursor: pointer !important;
  transition: color 0.15s ease, background-color 0.15s ease !important;
}

.figma-datepicker__clear-btn:hover {
  color: var(--danger-default, #e04434) !important;
  background-color: var(--danger-soft, rgba(224, 68, 52, 0.1)) !important;
}

.figma-datepicker__icon {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  color: var(--text-secondary, #506360) !important;
  flex-shrink: 0 !important;
  pointer-events: none !important;
}

.figma-datepicker__icon svg {
  width: 18px !important;
  height: 18px !important;
  stroke: currentColor !important;
  display: block !important;
}

.figma-datepicker__icon--disabled {
  color: var(--text-disabled, #aebab8) !important;
}

/* Error / Helper text */
.figma-datepicker__helper {
  font-family: var(--font-family-primary, "Lexend", sans-serif);
  font-size: 11px;
  color: var(--text-secondary, #6b7b78);
  margin-top: 4px;
  line-height: 1.3;
}

.figma-datepicker__helper--error {
  color: var(--danger-default, #e04434);
  font-weight: 500;
}

/* ==========================================================================
   react-datepicker Overrides & Floating Calendar Card
   Figma Specification Node: 166:5380 (Date Picker Calendar)
   ========================================================================== */

.react-datepicker-wrapper {
  display: block !important;
  width: 100% !important;
}

.react-datepicker__input-container {
  display: block !important;
  width: 100% !important;
}

/* Popper Container */
.figma-datepicker-popper {
  z-index: 99999 !important;
  padding-top: 6px !important;
}

/* Hide Default Triangle Arrow */
.figma-datepicker-popper .react-datepicker__triangle {
  display: none !important;
}

/* Calendar Card Container (Figma Node 166:5380)
   Width: 314px, Padding: 16px, Radius: 14px, Shadow: Drop Shadow */
.figma-datepicker-popper .react-datepicker {
  width: 314px !important;
  max-width: calc(100vw - 32px) !important;
  padding: 16px !important;
  background-color: var(--surface-primary, #ffffff) !important;
  border: 1px solid var(--border-subtle, #dce3e2) !important;
  border-radius: var(--radius-lg, 14px) !important;
  box-shadow: 0px 6px 16px -4px rgba(14, 26, 32, 0.1),
    0px 1px 2px rgba(14, 26, 32, 0.04) !important;
  font-family: var(--font-family-primary, "Lexend", sans-serif) !important;
  color: var(--text-primary, #142624) !important;
  box-sizing: border-box !important;
  display: flex !important;
  flex-direction: column !important;
  gap: 8px !important;
  overflow: hidden !important;
}

/* Month Container */
.figma-datepicker-popper .react-datepicker__month-container {
  float: none !important;
  background: transparent !important;
  width: 100% !important;
}

/* Calendar Header */
.figma-datepicker-popper .react-datepicker__header {
  background-color: transparent !important;
  border: none !important;
  padding: 0 !important;
  margin: 0 !important;
}

/* Custom Header Layout (Figma Node 166:5381) */
.figma-datepicker__custom-header {
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important;
  width: 100% !important;
  height: 32px !important;
  margin-bottom: 8px !important;
  box-sizing: border-box !important;
}

.figma-datepicker__nav-btn {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  width: 32px !important;
  height: 32px !important;
  min-width: 32px !important;
  border: none !important;
  background: transparent !important;
  border-radius: 6px !important;
  color: var(--text-primary, #142624) !important;
  cursor: pointer !important;
  padding: 0 !important;
  transition: background-color 0.15s ease, color 0.15s ease !important;
}

.figma-datepicker__nav-btn:hover:not(:disabled) {
  background-color: var(--surface-secondary, #f4f7f7) !important;
  color: var(--interactive-default, #0f766e) !important;
}

.figma-datepicker__nav-btn:disabled {
  opacity: 0.3 !important;
  cursor: not-allowed !important;
}

/* Header Title (Figma Node 166:5385: December 2024) */
.figma-datepicker__header-title-btn,
.figma-datepicker__header-title {
  font-family: var(--font-family-primary, "Lexend", sans-serif) !important;
  font-size: 14px !important;
  font-weight: 500 !important;
  color: var(--text-primary, #142624) !important;
  text-align: center !important;
  background: transparent !important;
  border: none !important;
  padding: 4px 8px !important;
  border-radius: 6px !important;
  cursor: pointer !important;
  transition: background-color 0.15s ease !important;
}

.figma-datepicker__header-title-btn:hover {
  background-color: var(--surface-secondary, #f4f7f7) !important;
}

/* Quick Month/Year Selection View */
.figma-datepicker__picker-header {
  display: flex !important;
  flex-direction: column !important;
  gap: 8px !important;
  margin-bottom: 8px !important;
  width: 100% !important;
}

.figma-datepicker__year-row {
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important;
  width: 100% !important;
}

.figma-datepicker__year-select {
  font-family: var(--font-family-primary, "Lexend", sans-serif) !important;
  font-size: 14px !important;
  font-weight: 600 !important;
  color: var(--text-primary, #142624) !important;
  background: var(--surface-secondary, #f4f7f7) !important;
  border: 1px solid var(--border-default, #cdd6d4) !important;
  border-radius: 6px !important;
  padding: 4px 12px !important;
  cursor: pointer !important;
  outline: none !important;
  transition: border-color 0.15s ease !important;
}

.figma-datepicker__year-select:focus {
  border-color: var(--interactive-default, #0f766e) !important;
}

.figma-datepicker__months-grid {
  display: grid !important;
  grid-template-columns: repeat(4, 1fr) !important;
  gap: 6px !important;
  width: 100% !important;
}

.figma-datepicker__month-cell {
  height: 32px !important;
  border-radius: 8px !important;
  border: none !important;
  background: transparent !important;
  font-family: var(--font-family-primary, "Lexend", sans-serif) !important;
  font-size: 12px !important;
  font-weight: 500 !important;
  color: var(--text-primary, #142624) !important;
  cursor: pointer !important;
  transition: background-color 0.15s ease, color 0.15s ease !important;
}

.figma-datepicker__month-cell:hover {
  background-color: var(--surface-secondary, #f4f7f7) !important;
  color: var(--interactive-default, #0f766e) !important;
}

.figma-datepicker__month-cell.is-selected {
  background-color: var(--interactive-default, #0f766e) !important;
  color: #ffffff !important;
}

/* Day Names Row (Figma Node 166:5389: Su, Mo, Tu, We, Th, Fr, Sa) */
.figma-datepicker-popper .react-datepicker__day-names {
  display: grid !important;
  grid-template-columns: repeat(7, 40px) !important;
  gap: 0 !important;
  justify-content: center !important;
  height: 32px !important;
  align-items: center !important;
  margin: 0 !important;
  border-bottom: none !important;
}

.figma-datepicker-popper .react-datepicker__day-name {
  width: 40px !important;
  height: 32px !important;
  margin: 0 !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  font-family: var(--font-family-primary, "Lexend", sans-serif) !important;
  font-size: 12px !important;
  font-weight: 500 !important;
  color: var(--text-tertiary, #6b7b78) !important;
  text-transform: none !important;
  letter-spacing: normal !important;
}

/* Month & Week Grid (Figma Node 166:5404: 7 columns of 40px) */
.figma-datepicker-popper .react-datepicker__month {
  margin: 0 !important;
  display: flex !important;
  flex-direction: column !important;
  gap: 0 !important;
}

.figma-datepicker-popper .react-datepicker__week {
  display: grid !important;
  grid-template-columns: repeat(7, 40px) !important;
  gap: 0 !important;
  justify-content: center !important;
  height: 36px !important;
  align-items: center !important;
}

/* Individual Day Cell (Figma Node 166:5410: 40px wide x 36px high) */
.figma-datepicker-popper .react-datepicker__day {
  width: 40px !important;
  height: 36px !important;
  margin: 0 !important;
  padding: 0 !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  border-radius: 9999px !important;
  font-family: var(--font-family-primary, "Lexend", sans-serif) !important;
  font-size: 13px !important;
  font-weight: 400 !important;
  color: var(--text-primary, #142624) !important;
  cursor: pointer !important;
  background-color: transparent !important;
  box-sizing: border-box !important;
  transition: background-color 0.15s ease, color 0.15s ease,
    border-color 0.15s ease !important;
  position: relative !important;
}

/* Hover Day */
.figma-datepicker-popper
  .react-datepicker__day:hover:not(.react-datepicker__day--disabled):not(
    .react-datepicker__day--selected
  ) {
  background-color: var(--surface-secondary, #f4f7f7) !important;
  color: var(--interactive-default, #0f766e) !important;
}

/* Selected Day (Figma Node 166:5440) */
.figma-datepicker-popper .react-datepicker__day--selected,
.figma-datepicker-popper .react-datepicker__day--keyboard-selected {
  background-color: var(--interactive-default, #0f766e) !important;
  color: #ffffff !important;
  border-radius: 9999px !important;
  font-weight: 500 !important;
  border: none !important;
}

.figma-datepicker-popper .react-datepicker__day--selected:hover {
  background-color: var(--interactive-hover, #0c5f59) !important;
  color: #ffffff !important;
}

/* Today Day when unselected (Figma Node 166:5455: 1px border #0f766e) */
.figma-datepicker-popper
  .react-datepicker__day--today:not(.react-datepicker__day--selected) {
  border: 1px solid var(--interactive-default, #0f766e) !important;
  border-radius: 9999px !important;
  background-color: transparent !important;
  color: var(--text-primary, #142624) !important;
  font-weight: 400 !important;
}

/* Range Selection */
.figma-datepicker-popper
  .react-datepicker__day--in-range:not(.react-datepicker__day--range-start):not(
    .react-datepicker__day--range-end
  ) {
  background-color: var(--interactive-soft-hover, #dcefec) !important;
  color: var(--text-primary, #142624) !important;
  border-radius: 0 !important;
}

.figma-datepicker-popper .react-datepicker__day--range-start {
  background-color: var(--interactive-default, #0f766e) !important;
  color: #ffffff !important;
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

.figma-datepicker-popper .react-datepicker__day--range-end {
  background-color: var(--interactive-default, #0f766e) !important;
  color: #ffffff !important;
  border-top-left-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
}

/* Days Outside Month - Hidden / Blank like Figma Empty Slots (166:5405) */
.figma-datepicker-popper .react-datepicker__day--outside-month {
  visibility: hidden !important;
  pointer-events: none !important;
}

/* Disabled Days */
.figma-datepicker-popper .react-datepicker__day--disabled {
  opacity: 0.3 !important;
  cursor: not-allowed !important;
  pointer-events: none !important;
}

/* ==========================================================================
   DARK THEME SPECIFICATIONS
   ========================================================================== */

/* Dark Theme for Input Trigger */
.figma-datepicker-root--dark .figma-datepicker__label,
[data-theme="dark"] .figma-datepicker__label,
.dark .figma-datepicker__label,
.quotation-editor-shell.dark .figma-datepicker__label {
  color: var(--text-primary, #f2f3f5) !important;
}

.figma-datepicker-root--dark .figma-datepicker__input-container,
[data-theme="dark"] .figma-datepicker__input-container,
.dark .figma-datepicker__input-container,
.quotation-editor-shell.dark .figma-datepicker__input-container {
  background-color: var(--surface-secondary, #22252a) !important;
  border-color: var(--border-subtle, #2c3036) !important;
  color: var(--text-primary, #f2f3f5) !important;
}

.figma-datepicker-root--dark
  .figma-datepicker__input-container:hover:not(
    .figma-datepicker__input-container--disabled
  ),
[data-theme="dark"]
  .figma-datepicker__input-container:hover:not(
    .figma-datepicker__input-container--disabled
  ),
.dark
  .figma-datepicker__input-container:hover:not(
    .figma-datepicker__input-container--disabled
  ),
.quotation-editor-shell.dark
  .figma-datepicker__input-container:hover:not(
    .figma-datepicker__input-container--disabled
  ) {
  border-color: #3a3f47 !important;
}

.figma-datepicker-root--dark .figma-datepicker__input,
[data-theme="dark"] .figma-datepicker__input,
.dark .figma-datepicker__input,
.quotation-editor-shell.dark .figma-datepicker__input {
  color: var(--text-primary, #f2f3f5) !important;
}

.figma-datepicker-root--dark .figma-datepicker__input::placeholder,
[data-theme="dark"] .figma-datepicker__input::placeholder,
.dark .figma-datepicker__input::placeholder,
.quotation-editor-shell.dark .figma-datepicker__input::placeholder {
  color: var(--text-tertiary, #9299a5) !important;
}

.figma-datepicker-root--dark .figma-datepicker__icon,
[data-theme="dark"] .figma-datepicker__icon,
.dark .figma-datepicker__icon,
.quotation-editor-shell.dark .figma-datepicker__icon {
  color: var(--text-secondary, #879b97) !important;
}

/* Dark Theme for Calendar Panel */
.figma-datepicker-popper--dark .react-datepicker,
[data-theme="dark"] .figma-datepicker-popper .react-datepicker,
.dark .figma-datepicker-popper .react-datepicker {
  background-color: var(--surface-primary, #191b1f) !important;
  border-color: var(--border-subtle, #2c3036) !important;
  color: var(--text-primary, #f2f3f5) !important;
  box-shadow: 0 12px 28px -5px rgba(0, 0, 0, 0.5),
    0 8px 10px -6px rgba(0, 0, 0, 0.4) !important;
}

.figma-datepicker-popper--dark .figma-datepicker__nav-btn,
[data-theme="dark"] .figma-datepicker__nav-btn,
.dark .figma-datepicker__nav-btn {
  color: #f2f3f5 !important;
}

.figma-datepicker-popper--dark .figma-datepicker__nav-btn:hover:not(:disabled),
[data-theme="dark"] .figma-datepicker__nav-btn:hover:not(:disabled),
.dark .figma-datepicker__nav-btn:hover:not(:disabled) {
  background-color: #22252a !important;
}

.figma-datepicker-popper--dark .figma-datepicker__header-title-btn,
[data-theme="dark"] .figma-datepicker__header-title-btn,
.dark .figma-datepicker__header-title-btn {
  color: #f2f3f5 !important;
}

.figma-datepicker-popper--dark .figma-datepicker__header-title-btn:hover,
[data-theme="dark"] .figma-datepicker__header-title-btn:hover,
.dark .figma-datepicker__header-title-btn:hover {
  background-color: #22252a !important;
}

.figma-datepicker-popper--dark .figma-datepicker__year-select,
[data-theme="dark"] .figma-datepicker__year-select,
.dark .figma-datepicker__year-select {
  background-color: #22252a !important;
  border-color: #2c3036 !important;
  color: #f2f3f5 !important;
}

.figma-datepicker-popper--dark .figma-datepicker__month-cell,
[data-theme="dark"] .figma-datepicker__month-cell,
.dark .figma-datepicker__month-cell {
  color: #f2f3f5 !important;
}

.figma-datepicker-popper--dark .figma-datepicker__month-cell:hover,
[data-theme="dark"] .figma-datepicker__month-cell:hover,
.dark .figma-datepicker__month-cell:hover {
  background-color: #22252a !important;
  color: #43a79c !important;
}

.figma-datepicker-popper--dark .figma-datepicker__month-cell.is-selected,
[data-theme="dark"] .figma-datepicker__month-cell.is-selected,
.dark .figma-datepicker__month-cell.is-selected {
  background-color: #0f766e !important;
  color: #ffffff !important;
}

.figma-datepicker-popper--dark .react-datepicker__day-name,
[data-theme="dark"] .react-datepicker__day-name,
.dark .react-datepicker__day-name {
  color: #9299a5 !important;
}

.figma-datepicker-popper--dark .react-datepicker__day,
[data-theme="dark"] .react-datepicker__day,
.dark .react-datepicker__day {
  color: #f2f3f5 !important;
}

.figma-datepicker-popper--dark
  .react-datepicker__day:hover:not(.react-datepicker__day--disabled):not(
    .react-datepicker__day--selected
  ),
[data-theme="dark"]
  .react-datepicker__day:hover:not(.react-datepicker__day--disabled):not(
    .react-datepicker__day--selected
  ),
.dark
  .react-datepicker__day:hover:not(.react-datepicker__day--disabled):not(
    .react-datepicker__day--selected
  ) {
  background-color: #22252a !important;
  color: #43a79c !important;
}

.figma-datepicker-popper--dark
  .react-datepicker__day--today:not(.react-datepicker__day--selected),
[data-theme="dark"]
  .react-datepicker__day--today:not(.react-datepicker__day--selected),
.dark .react-datepicker__day--today:not(.react-datepicker__day--selected) {
  border-color: #43a79c !important;
  color: #f2f3f5 !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/DatePicker/DatePicker.css"],"names":[],"mappings":"AAAA;;;+EAG+E;;AAE/E,iBAAiB;AACjB;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,4EAA4E;EAC5E,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,WAAW;AACb;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,mBAAmB;EACnB,6DAA6D;EAC7D,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,mCAAmC;EACnC,kBAAkB;EAClB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,0CAA0C;AAC1C;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,yCAAyC;EACzC,mBAAmB;EACnB,uBAAuB;EACvB,iCAAiC;EACjC,4DAA4D;EAC5D,2DAA2D;EAC3D,gDAAgD;EAChD,8CAA8C;EAC9C,iCAAiC;EACjC,0BAA0B;EAC1B,oCAA4B;UAA5B,4BAA4B;EAC5B;0CACwC;EACxC,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;;;EAGE,sDAAsD;AACxD;;AAEA;;;;EAIE,4DAA4D;EAC5D,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA,kBAAkB;AAClB;EACE,uBAAuB;EACvB,0BAA0B;EAC1B,+CAA+C;AACjD;;AAEA;EACE,uBAAuB;EACvB,iCAAiC;EACjC,gDAAgD;AAClD;;AAEA;EACE,uBAAuB;EACvB,0BAA0B;EAC1B,gDAAgD;AAClD;;AAEA,mBAAmB;AACnB;EACE,8DAA8D;EAC9D,sDAAsD;EACtD,+CAA+C;EAC/C,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA,gBAAgB;AAChB;EACE,uDAAuD;AACzD;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,8CAA8C;AAC9C;EACE,oBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,kCAAkC;EAClC,wBAAwB;EACxB,wEAAwE;EACxE,0BAA0B;EAC1B,2BAA2B;EAC3B,8CAA8C;EAC9C,qBAAqB;EACrB,oBAAoB;EACpB,8BAA8B;EAC9B,0BAA0B;EAC1B,oCAA4B;UAA5B,4BAA4B;AAC9B;;AAEA;EACE,+CAA+C;EAC/C,qBAAqB;AACvB;;AAEA;EACE,+CAA+C;EAC/C,8BAA8B;AAChC;;AAEA,gDAAgD;AAChD;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,uBAAuB;EACvB,kCAAkC;EAClC,+CAA+C;EAC/C,uBAAuB;EACvB,+CAA+C;EAC/C,0BAA0B;EAC1B,oEAAoE;AACtE;;AAEA;EACE,gDAAgD;EAChD,uEAAuE;AACzE;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,gDAAgD;EAChD,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA;EACE,+CAA+C;AACjD;;AAEA,wBAAwB;AACxB;EACE,6DAA6D;EAC7D,eAAe;EACf,qCAAqC;EACrC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;;;+EAG+E;;AAE/E;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA,qBAAqB;AACrB;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA,gCAAgC;AAChC;EACE,wBAAwB;AAC1B;;AAEA;mEACmE;AACnE;EACE,uBAAuB;EACvB,wCAAwC;EACxC,wBAAwB;EACxB,4DAA4D;EAC5D,0DAA0D;EAC1D,gDAAgD;EAChD;iDAC+C;EAC/C,wEAAwE;EACxE,8CAA8C;EAC9C,iCAAiC;EACjC,wBAAwB;EACxB,iCAAiC;EACjC,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA,oBAAoB;AACpB;EACE,sBAAsB;EACtB,kCAAkC;EAClC,sBAAsB;AACxB;;AAEA,oBAAoB;AACpB;EACE,wCAAwC;EACxC,uBAAuB;EACvB,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA,+CAA+C;AAC/C;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,yCAAyC;EACzC,sBAAsB;EACtB,uBAAuB;EACvB,6BAA6B;EAC7B,iCAAiC;AACnC;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,sBAAsB;EACtB,uBAAuB;EACvB,0BAA0B;EAC1B,uBAAuB;EACvB,kCAAkC;EAClC,6BAA6B;EAC7B,8CAA8C;EAC9C,0BAA0B;EAC1B,qBAAqB;EACrB,oEAAoE;AACtE;;AAEA;EACE,8DAA8D;EAC9D,qDAAqD;AACvD;;AAEA;EACE,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA,sDAAsD;AACtD;;EAEE,wEAAwE;EACxE,0BAA0B;EAC1B,2BAA2B;EAC3B,8CAA8C;EAC9C,6BAA6B;EAC7B,kCAAkC;EAClC,uBAAuB;EACvB,2BAA2B;EAC3B,6BAA6B;EAC7B,0BAA0B;EAC1B,kDAAkD;AACpD;;AAEA;EACE,8DAA8D;AAChE;;AAEA,oCAAoC;AACpC;EACE,wBAAwB;EACxB,iCAAiC;EACjC,mBAAmB;EACnB,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,yCAAyC;EACzC,sBAAsB;AACxB;;AAEA;EACE,wEAAwE;EACxE,0BAA0B;EAC1B,2BAA2B;EAC3B,8CAA8C;EAC9C,wDAAwD;EACxD,2DAA2D;EAC3D,6BAA6B;EAC7B,4BAA4B;EAC5B,0BAA0B;EAC1B,wBAAwB;EACxB,8CAA8C;AAChD;;AAEA;EACE,4DAA4D;AAC9D;;AAEA;EACE,wBAAwB;EACxB,gDAAgD;EAChD,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,uBAAuB;EACvB,kCAAkC;EAClC,wEAAwE;EACxE,0BAA0B;EAC1B,2BAA2B;EAC3B,8CAA8C;EAC9C,0BAA0B;EAC1B,oEAAoE;AACtE;;AAEA;EACE,8DAA8D;EAC9D,qDAAqD;AACvD;;AAEA;EACE,gEAAgE;EAChE,yBAAyB;AAC3B;;AAEA,oEAAoE;AACpE;EACE,wBAAwB;EACxB,iDAAiD;EACjD,iBAAiB;EACjB,kCAAkC;EAClC,uBAAuB;EACvB,8BAA8B;EAC9B,oBAAoB;EACpB,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,oBAAoB;EACpB,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,wEAAwE;EACxE,0BAA0B;EAC1B,2BAA2B;EAC3B,+CAA+C;EAC/C,+BAA+B;EAC/B,iCAAiC;AACnC;;AAEA,+DAA+D;AAC/D;EACE,oBAAoB;EACpB,wBAAwB;EACxB,iCAAiC;EACjC,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;EACxB,iDAAiD;EACjD,iBAAiB;EACjB,kCAAkC;EAClC,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA,qEAAqE;AACrE;EACE,sBAAsB;EACtB,uBAAuB;EACvB,oBAAoB;EACpB,qBAAqB;EACrB,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,gCAAgC;EAChC,wEAAwE;EACxE,0BAA0B;EAC1B,2BAA2B;EAC3B,8CAA8C;EAC9C,0BAA0B;EAC1B,wCAAwC;EACxC,iCAAiC;EACjC;sCACoC;EACpC,6BAA6B;AAC/B;;AAEA,cAAc;AACd;;;;EAIE,8DAA8D;EAC9D,qDAAqD;AACvD;;AAEA,uCAAuC;AACvC;;EAEE,gEAAgE;EAChE,yBAAyB;EACzB,gCAAgC;EAChC,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,8DAA8D;EAC9D,yBAAyB;AAC3B;;AAEA,wEAAwE;AACxE;;EAEE,gEAAgE;EAChE,gCAAgC;EAChC,wCAAwC;EACxC,8CAA8C;EAC9C,2BAA2B;AAC7B;;AAEA,oBAAoB;AACpB;;;;EAIE,mEAAmE;EACnE,8CAA8C;EAC9C,2BAA2B;AAC7B;;AAEA;EACE,gEAAgE;EAChE,yBAAyB;EACzB,qCAAqC;EACrC,wCAAwC;AAC1C;;AAEA;EACE,gEAAgE;EAChE,yBAAyB;EACzB,oCAAoC;EACpC,uCAAuC;AACzC;;AAEA,0EAA0E;AAC1E;EACE,6BAA6B;EAC7B,+BAA+B;AACjC;;AAEA,kBAAkB;AAClB;EACE,uBAAuB;EACvB,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;;+EAE+E;;AAE/E,iCAAiC;AACjC;;;;EAIE,8CAA8C;AAChD;;AAEA;;;;EAIE,8DAA8D;EAC9D,sDAAsD;EACtD,8CAA8C;AAChD;;AAEA;;;;;;;;;;;;;;;;EAgBE,gCAAgC;AAClC;;AAEA;;;;EAIE,8CAA8C;AAChD;;AAEA;;;;EAIE,+CAA+C;AACjD;;AAEA;;;;EAIE,gDAAgD;AAClD;;AAEA,kCAAkC;AAClC;;;EAGE,4DAA4D;EAC5D,sDAAsD;EACtD,8CAA8C;EAC9C;iDAC+C;AACjD;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;;;EAGE,oCAAoC;AACtC;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;;;EAGE,oCAAoC;AACtC;;AAEA;;;EAGE,oCAAoC;EACpC,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;;;EAGE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;;;EAGE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;;;;;;;;;;;;EAYE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;;;;;EAKE,gCAAgC;EAChC,yBAAyB;AAC3B","sourcesContent":["/* ==========================================================================\n   Figma Datepicker Design System Styles\n   Figma Specification Node: 140:10389 (Calendar 166:5380, Input 166:5483)\n   ========================================================================== */\n\n/* Root Wrapper */\n.figma-datepicker-root {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  font-family: var(--font-family-primary, \"Lexend\", -apple-system, sans-serif);\n  position: relative;\n  text-align: left;\n}\n\n.figma-datepicker-root--inline {\n  display: inline-flex;\n  width: auto;\n}\n\n/* Label (Figma Node 166:5484) */\n.figma-datepicker__label {\n  display: flex;\n  align-items: center;\n  font-family: var(--font-family-primary, \"Lexend\", sans-serif);\n  font-size: 13px;\n  font-weight: 500;\n  line-height: normal;\n  color: var(--text-primary, #142624);\n  margin-bottom: 6px;\n  cursor: pointer;\n  user-select: none;\n}\n\n.figma-datepicker__required {\n  color: var(--danger-default, #e04434);\n  margin-left: 3px;\n  font-weight: 600;\n}\n\n/* Input Container (Figma Node 166:5485) */\n.figma-datepicker__input-container {\n  display: flex !important;\n  align-items: center !important;\n  justify-content: space-between !important;\n  gap: 8px !important;\n  height: 40px !important;\n  padding: 0 12px 0 14px !important;\n  background-color: var(--surface-primary, #ffffff) !important;\n  border: 1px solid var(--border-default, #cdd6d4) !important;\n  border-radius: var(--radius-md, 10px) !important;\n  color: var(--text-primary, #142624) !important;\n  box-sizing: border-box !important;\n  cursor: pointer !important;\n  user-select: none !important;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease,\n    background-color 0.15s ease !important;\n  position: relative !important;\n  width: 100% !important;\n}\n\n.figma-datepicker__input-container:hover:not(\n    .figma-datepicker__input-container--disabled\n  ) {\n  border-color: var(--border-strong, #aebab8) !important;\n}\n\n.figma-datepicker__input-container:focus-within:not(\n    .figma-datepicker__input-container--disabled\n  ),\n.figma-datepicker__input-container--focused {\n  border-color: var(--interactive-default, #0f766e) !important;\n  box-shadow: none !important;\n  outline: none !important;\n}\n\n/* Size Variants */\n.figma-datepicker__input-container--sm {\n  height: 32px !important;\n  padding: 0 10px !important;\n  border-radius: var(--radius-sm, 6px) !important;\n}\n\n.figma-datepicker__input-container--md {\n  height: 40px !important;\n  padding: 0 12px 0 14px !important;\n  border-radius: var(--radius-md, 10px) !important;\n}\n\n.figma-datepicker__input-container--lg {\n  height: 48px !important;\n  padding: 0 16px !important;\n  border-radius: var(--radius-md, 10px) !important;\n}\n\n/* Disabled State */\n.figma-datepicker__input-container--disabled {\n  background-color: var(--surface-secondary, #f4f7f7) !important;\n  border-color: var(--border-subtle, #e8edec) !important;\n  color: var(--text-disabled, #aebab8) !important;\n  cursor: not-allowed !important;\n  opacity: 0.8 !important;\n}\n\n/* Error State */\n.figma-datepicker__input-container--error {\n  border-color: var(--danger-default, #e04434) !important;\n}\n\n.figma-datepicker__input-container--error:focus-within {\n  box-shadow: none !important;\n}\n\n/* Inner Input Element (Figma Node 166:5486) */\n.figma-datepicker__input {\n  flex: 1 1 0% !important;\n  min-width: 0 !important;\n  border: none !important;\n  background: transparent !important;\n  outline: none !important;\n  font-family: var(--font-family-primary, \"Lexend\", sans-serif) !important;\n  font-size: 14px !important;\n  font-weight: 400 !important;\n  color: var(--text-primary, #142624) !important;\n  padding: 0 !important;\n  margin: 0 !important;\n  line-height: normal !important;\n  cursor: pointer !important;\n  user-select: none !important;\n}\n\n.figma-datepicker__input::placeholder {\n  color: var(--text-tertiary, #6b7b78) !important;\n  opacity: 1 !important;\n}\n\n.figma-datepicker__input:disabled {\n  color: var(--text-disabled, #aebab8) !important;\n  cursor: not-allowed !important;\n}\n\n/* Right Actions / Icons (Figma Node 166:5487) */\n.figma-datepicker__actions {\n  display: flex !important;\n  align-items: center !important;\n  gap: 6px !important;\n  flex-shrink: 0 !important;\n}\n\n.figma-datepicker__clear-btn {\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  border: none !important;\n  background: transparent !important;\n  color: var(--text-tertiary, #8a9896) !important;\n  padding: 2px !important;\n  border-radius: var(--radius-xs, 4px) !important;\n  cursor: pointer !important;\n  transition: color 0.15s ease, background-color 0.15s ease !important;\n}\n\n.figma-datepicker__clear-btn:hover {\n  color: var(--danger-default, #e04434) !important;\n  background-color: var(--danger-soft, rgba(224, 68, 52, 0.1)) !important;\n}\n\n.figma-datepicker__icon {\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  color: var(--text-secondary, #506360) !important;\n  flex-shrink: 0 !important;\n  pointer-events: none !important;\n}\n\n.figma-datepicker__icon svg {\n  width: 18px !important;\n  height: 18px !important;\n  stroke: currentColor !important;\n  display: block !important;\n}\n\n.figma-datepicker__icon--disabled {\n  color: var(--text-disabled, #aebab8) !important;\n}\n\n/* Error / Helper text */\n.figma-datepicker__helper {\n  font-family: var(--font-family-primary, \"Lexend\", sans-serif);\n  font-size: 11px;\n  color: var(--text-secondary, #6b7b78);\n  margin-top: 4px;\n  line-height: 1.3;\n}\n\n.figma-datepicker__helper--error {\n  color: var(--danger-default, #e04434);\n  font-weight: 500;\n}\n\n/* ==========================================================================\n   react-datepicker Overrides & Floating Calendar Card\n   Figma Specification Node: 166:5380 (Date Picker Calendar)\n   ========================================================================== */\n\n.react-datepicker-wrapper {\n  display: block !important;\n  width: 100% !important;\n}\n\n.react-datepicker__input-container {\n  display: block !important;\n  width: 100% !important;\n}\n\n/* Popper Container */\n.figma-datepicker-popper {\n  z-index: 99999 !important;\n  padding-top: 6px !important;\n}\n\n/* Hide Default Triangle Arrow */\n.figma-datepicker-popper .react-datepicker__triangle {\n  display: none !important;\n}\n\n/* Calendar Card Container (Figma Node 166:5380)\n   Width: 314px, Padding: 16px, Radius: 14px, Shadow: Drop Shadow */\n.figma-datepicker-popper .react-datepicker {\n  width: 314px !important;\n  max-width: calc(100vw - 32px) !important;\n  padding: 16px !important;\n  background-color: var(--surface-primary, #ffffff) !important;\n  border: 1px solid var(--border-subtle, #dce3e2) !important;\n  border-radius: var(--radius-lg, 14px) !important;\n  box-shadow: 0px 6px 16px -4px rgba(14, 26, 32, 0.1),\n    0px 1px 2px rgba(14, 26, 32, 0.04) !important;\n  font-family: var(--font-family-primary, \"Lexend\", sans-serif) !important;\n  color: var(--text-primary, #142624) !important;\n  box-sizing: border-box !important;\n  display: flex !important;\n  flex-direction: column !important;\n  gap: 8px !important;\n  overflow: hidden !important;\n}\n\n/* Month Container */\n.figma-datepicker-popper .react-datepicker__month-container {\n  float: none !important;\n  background: transparent !important;\n  width: 100% !important;\n}\n\n/* Calendar Header */\n.figma-datepicker-popper .react-datepicker__header {\n  background-color: transparent !important;\n  border: none !important;\n  padding: 0 !important;\n  margin: 0 !important;\n}\n\n/* Custom Header Layout (Figma Node 166:5381) */\n.figma-datepicker__custom-header {\n  display: flex !important;\n  align-items: center !important;\n  justify-content: space-between !important;\n  width: 100% !important;\n  height: 32px !important;\n  margin-bottom: 8px !important;\n  box-sizing: border-box !important;\n}\n\n.figma-datepicker__nav-btn {\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  width: 32px !important;\n  height: 32px !important;\n  min-width: 32px !important;\n  border: none !important;\n  background: transparent !important;\n  border-radius: 6px !important;\n  color: var(--text-primary, #142624) !important;\n  cursor: pointer !important;\n  padding: 0 !important;\n  transition: background-color 0.15s ease, color 0.15s ease !important;\n}\n\n.figma-datepicker__nav-btn:hover:not(:disabled) {\n  background-color: var(--surface-secondary, #f4f7f7) !important;\n  color: var(--interactive-default, #0f766e) !important;\n}\n\n.figma-datepicker__nav-btn:disabled {\n  opacity: 0.3 !important;\n  cursor: not-allowed !important;\n}\n\n/* Header Title (Figma Node 166:5385: December 2024) */\n.figma-datepicker__header-title-btn,\n.figma-datepicker__header-title {\n  font-family: var(--font-family-primary, \"Lexend\", sans-serif) !important;\n  font-size: 14px !important;\n  font-weight: 500 !important;\n  color: var(--text-primary, #142624) !important;\n  text-align: center !important;\n  background: transparent !important;\n  border: none !important;\n  padding: 4px 8px !important;\n  border-radius: 6px !important;\n  cursor: pointer !important;\n  transition: background-color 0.15s ease !important;\n}\n\n.figma-datepicker__header-title-btn:hover {\n  background-color: var(--surface-secondary, #f4f7f7) !important;\n}\n\n/* Quick Month/Year Selection View */\n.figma-datepicker__picker-header {\n  display: flex !important;\n  flex-direction: column !important;\n  gap: 8px !important;\n  margin-bottom: 8px !important;\n  width: 100% !important;\n}\n\n.figma-datepicker__year-row {\n  display: flex !important;\n  align-items: center !important;\n  justify-content: space-between !important;\n  width: 100% !important;\n}\n\n.figma-datepicker__year-select {\n  font-family: var(--font-family-primary, \"Lexend\", sans-serif) !important;\n  font-size: 14px !important;\n  font-weight: 600 !important;\n  color: var(--text-primary, #142624) !important;\n  background: var(--surface-secondary, #f4f7f7) !important;\n  border: 1px solid var(--border-default, #cdd6d4) !important;\n  border-radius: 6px !important;\n  padding: 4px 12px !important;\n  cursor: pointer !important;\n  outline: none !important;\n  transition: border-color 0.15s ease !important;\n}\n\n.figma-datepicker__year-select:focus {\n  border-color: var(--interactive-default, #0f766e) !important;\n}\n\n.figma-datepicker__months-grid {\n  display: grid !important;\n  grid-template-columns: repeat(4, 1fr) !important;\n  gap: 6px !important;\n  width: 100% !important;\n}\n\n.figma-datepicker__month-cell {\n  height: 32px !important;\n  border-radius: 8px !important;\n  border: none !important;\n  background: transparent !important;\n  font-family: var(--font-family-primary, \"Lexend\", sans-serif) !important;\n  font-size: 12px !important;\n  font-weight: 500 !important;\n  color: var(--text-primary, #142624) !important;\n  cursor: pointer !important;\n  transition: background-color 0.15s ease, color 0.15s ease !important;\n}\n\n.figma-datepicker__month-cell:hover {\n  background-color: var(--surface-secondary, #f4f7f7) !important;\n  color: var(--interactive-default, #0f766e) !important;\n}\n\n.figma-datepicker__month-cell.is-selected {\n  background-color: var(--interactive-default, #0f766e) !important;\n  color: #ffffff !important;\n}\n\n/* Day Names Row (Figma Node 166:5389: Su, Mo, Tu, We, Th, Fr, Sa) */\n.figma-datepicker-popper .react-datepicker__day-names {\n  display: grid !important;\n  grid-template-columns: repeat(7, 40px) !important;\n  gap: 0 !important;\n  justify-content: center !important;\n  height: 32px !important;\n  align-items: center !important;\n  margin: 0 !important;\n  border-bottom: none !important;\n}\n\n.figma-datepicker-popper .react-datepicker__day-name {\n  width: 40px !important;\n  height: 32px !important;\n  margin: 0 !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  font-family: var(--font-family-primary, \"Lexend\", sans-serif) !important;\n  font-size: 12px !important;\n  font-weight: 500 !important;\n  color: var(--text-tertiary, #6b7b78) !important;\n  text-transform: none !important;\n  letter-spacing: normal !important;\n}\n\n/* Month & Week Grid (Figma Node 166:5404: 7 columns of 40px) */\n.figma-datepicker-popper .react-datepicker__month {\n  margin: 0 !important;\n  display: flex !important;\n  flex-direction: column !important;\n  gap: 0 !important;\n}\n\n.figma-datepicker-popper .react-datepicker__week {\n  display: grid !important;\n  grid-template-columns: repeat(7, 40px) !important;\n  gap: 0 !important;\n  justify-content: center !important;\n  height: 36px !important;\n  align-items: center !important;\n}\n\n/* Individual Day Cell (Figma Node 166:5410: 40px wide x 36px high) */\n.figma-datepicker-popper .react-datepicker__day {\n  width: 40px !important;\n  height: 36px !important;\n  margin: 0 !important;\n  padding: 0 !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  border-radius: 9999px !important;\n  font-family: var(--font-family-primary, \"Lexend\", sans-serif) !important;\n  font-size: 13px !important;\n  font-weight: 400 !important;\n  color: var(--text-primary, #142624) !important;\n  cursor: pointer !important;\n  background-color: transparent !important;\n  box-sizing: border-box !important;\n  transition: background-color 0.15s ease, color 0.15s ease,\n    border-color 0.15s ease !important;\n  position: relative !important;\n}\n\n/* Hover Day */\n.figma-datepicker-popper\n  .react-datepicker__day:hover:not(.react-datepicker__day--disabled):not(\n    .react-datepicker__day--selected\n  ) {\n  background-color: var(--surface-secondary, #f4f7f7) !important;\n  color: var(--interactive-default, #0f766e) !important;\n}\n\n/* Selected Day (Figma Node 166:5440) */\n.figma-datepicker-popper .react-datepicker__day--selected,\n.figma-datepicker-popper .react-datepicker__day--keyboard-selected {\n  background-color: var(--interactive-default, #0f766e) !important;\n  color: #ffffff !important;\n  border-radius: 9999px !important;\n  font-weight: 500 !important;\n  border: none !important;\n}\n\n.figma-datepicker-popper .react-datepicker__day--selected:hover {\n  background-color: var(--interactive-hover, #0c5f59) !important;\n  color: #ffffff !important;\n}\n\n/* Today Day when unselected (Figma Node 166:5455: 1px border #0f766e) */\n.figma-datepicker-popper\n  .react-datepicker__day--today:not(.react-datepicker__day--selected) {\n  border: 1px solid var(--interactive-default, #0f766e) !important;\n  border-radius: 9999px !important;\n  background-color: transparent !important;\n  color: var(--text-primary, #142624) !important;\n  font-weight: 400 !important;\n}\n\n/* Range Selection */\n.figma-datepicker-popper\n  .react-datepicker__day--in-range:not(.react-datepicker__day--range-start):not(\n    .react-datepicker__day--range-end\n  ) {\n  background-color: var(--interactive-soft-hover, #dcefec) !important;\n  color: var(--text-primary, #142624) !important;\n  border-radius: 0 !important;\n}\n\n.figma-datepicker-popper .react-datepicker__day--range-start {\n  background-color: var(--interactive-default, #0f766e) !important;\n  color: #ffffff !important;\n  border-top-right-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n}\n\n.figma-datepicker-popper .react-datepicker__day--range-end {\n  background-color: var(--interactive-default, #0f766e) !important;\n  color: #ffffff !important;\n  border-top-left-radius: 0 !important;\n  border-bottom-left-radius: 0 !important;\n}\n\n/* Days Outside Month - Hidden / Blank like Figma Empty Slots (166:5405) */\n.figma-datepicker-popper .react-datepicker__day--outside-month {\n  visibility: hidden !important;\n  pointer-events: none !important;\n}\n\n/* Disabled Days */\n.figma-datepicker-popper .react-datepicker__day--disabled {\n  opacity: 0.3 !important;\n  cursor: not-allowed !important;\n  pointer-events: none !important;\n}\n\n/* ==========================================================================\n   DARK THEME SPECIFICATIONS\n   ========================================================================== */\n\n/* Dark Theme for Input Trigger */\n.figma-datepicker-root--dark .figma-datepicker__label,\n[data-theme=\"dark\"] .figma-datepicker__label,\n.dark .figma-datepicker__label,\n.quotation-editor-shell.dark .figma-datepicker__label {\n  color: var(--text-primary, #f2f3f5) !important;\n}\n\n.figma-datepicker-root--dark .figma-datepicker__input-container,\n[data-theme=\"dark\"] .figma-datepicker__input-container,\n.dark .figma-datepicker__input-container,\n.quotation-editor-shell.dark .figma-datepicker__input-container {\n  background-color: var(--surface-secondary, #22252a) !important;\n  border-color: var(--border-subtle, #2c3036) !important;\n  color: var(--text-primary, #f2f3f5) !important;\n}\n\n.figma-datepicker-root--dark\n  .figma-datepicker__input-container:hover:not(\n    .figma-datepicker__input-container--disabled\n  ),\n[data-theme=\"dark\"]\n  .figma-datepicker__input-container:hover:not(\n    .figma-datepicker__input-container--disabled\n  ),\n.dark\n  .figma-datepicker__input-container:hover:not(\n    .figma-datepicker__input-container--disabled\n  ),\n.quotation-editor-shell.dark\n  .figma-datepicker__input-container:hover:not(\n    .figma-datepicker__input-container--disabled\n  ) {\n  border-color: #3a3f47 !important;\n}\n\n.figma-datepicker-root--dark .figma-datepicker__input,\n[data-theme=\"dark\"] .figma-datepicker__input,\n.dark .figma-datepicker__input,\n.quotation-editor-shell.dark .figma-datepicker__input {\n  color: var(--text-primary, #f2f3f5) !important;\n}\n\n.figma-datepicker-root--dark .figma-datepicker__input::placeholder,\n[data-theme=\"dark\"] .figma-datepicker__input::placeholder,\n.dark .figma-datepicker__input::placeholder,\n.quotation-editor-shell.dark .figma-datepicker__input::placeholder {\n  color: var(--text-tertiary, #9299a5) !important;\n}\n\n.figma-datepicker-root--dark .figma-datepicker__icon,\n[data-theme=\"dark\"] .figma-datepicker__icon,\n.dark .figma-datepicker__icon,\n.quotation-editor-shell.dark .figma-datepicker__icon {\n  color: var(--text-secondary, #879b97) !important;\n}\n\n/* Dark Theme for Calendar Panel */\n.figma-datepicker-popper--dark .react-datepicker,\n[data-theme=\"dark\"] .figma-datepicker-popper .react-datepicker,\n.dark .figma-datepicker-popper .react-datepicker {\n  background-color: var(--surface-primary, #191b1f) !important;\n  border-color: var(--border-subtle, #2c3036) !important;\n  color: var(--text-primary, #f2f3f5) !important;\n  box-shadow: 0 12px 28px -5px rgba(0, 0, 0, 0.5),\n    0 8px 10px -6px rgba(0, 0, 0, 0.4) !important;\n}\n\n.figma-datepicker-popper--dark .figma-datepicker__nav-btn,\n[data-theme=\"dark\"] .figma-datepicker__nav-btn,\n.dark .figma-datepicker__nav-btn {\n  color: #f2f3f5 !important;\n}\n\n.figma-datepicker-popper--dark .figma-datepicker__nav-btn:hover:not(:disabled),\n[data-theme=\"dark\"] .figma-datepicker__nav-btn:hover:not(:disabled),\n.dark .figma-datepicker__nav-btn:hover:not(:disabled) {\n  background-color: #22252a !important;\n}\n\n.figma-datepicker-popper--dark .figma-datepicker__header-title-btn,\n[data-theme=\"dark\"] .figma-datepicker__header-title-btn,\n.dark .figma-datepicker__header-title-btn {\n  color: #f2f3f5 !important;\n}\n\n.figma-datepicker-popper--dark .figma-datepicker__header-title-btn:hover,\n[data-theme=\"dark\"] .figma-datepicker__header-title-btn:hover,\n.dark .figma-datepicker__header-title-btn:hover {\n  background-color: #22252a !important;\n}\n\n.figma-datepicker-popper--dark .figma-datepicker__year-select,\n[data-theme=\"dark\"] .figma-datepicker__year-select,\n.dark .figma-datepicker__year-select {\n  background-color: #22252a !important;\n  border-color: #2c3036 !important;\n  color: #f2f3f5 !important;\n}\n\n.figma-datepicker-popper--dark .figma-datepicker__month-cell,\n[data-theme=\"dark\"] .figma-datepicker__month-cell,\n.dark .figma-datepicker__month-cell {\n  color: #f2f3f5 !important;\n}\n\n.figma-datepicker-popper--dark .figma-datepicker__month-cell:hover,\n[data-theme=\"dark\"] .figma-datepicker__month-cell:hover,\n.dark .figma-datepicker__month-cell:hover {\n  background-color: #22252a !important;\n  color: #43a79c !important;\n}\n\n.figma-datepicker-popper--dark .figma-datepicker__month-cell.is-selected,\n[data-theme=\"dark\"] .figma-datepicker__month-cell.is-selected,\n.dark .figma-datepicker__month-cell.is-selected {\n  background-color: #0f766e !important;\n  color: #ffffff !important;\n}\n\n.figma-datepicker-popper--dark .react-datepicker__day-name,\n[data-theme=\"dark\"] .react-datepicker__day-name,\n.dark .react-datepicker__day-name {\n  color: #9299a5 !important;\n}\n\n.figma-datepicker-popper--dark .react-datepicker__day,\n[data-theme=\"dark\"] .react-datepicker__day,\n.dark .react-datepicker__day {\n  color: #f2f3f5 !important;\n}\n\n.figma-datepicker-popper--dark\n  .react-datepicker__day:hover:not(.react-datepicker__day--disabled):not(\n    .react-datepicker__day--selected\n  ),\n[data-theme=\"dark\"]\n  .react-datepicker__day:hover:not(.react-datepicker__day--disabled):not(\n    .react-datepicker__day--selected\n  ),\n.dark\n  .react-datepicker__day:hover:not(.react-datepicker__day--disabled):not(\n    .react-datepicker__day--selected\n  ) {\n  background-color: #22252a !important;\n  color: #43a79c !important;\n}\n\n.figma-datepicker-popper--dark\n  .react-datepicker__day--today:not(.react-datepicker__day--selected),\n[data-theme=\"dark\"]\n  .react-datepicker__day--today:not(.react-datepicker__day--selected),\n.dark .react-datepicker__day--today:not(.react-datepicker__day--selected) {\n  border-color: #43a79c !important;\n  color: #f2f3f5 !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
